import ApiService from "../../core/service/ApiService";
import {useEffect, useRef, useState} from "react";
import {Button, Collapse, Form, Input, Select, Typography} from "antd";
import { t } from 'i18next';

export default function PosTransfer({appointmentId, payment, patientId, onSuccess}) {
    const [posDevices, setPosDevices] = useState([])
    const [type, setType] = useState(1)
    const formRef = useRef()
    const [error, setError] = useState(null)

    const getPosDevices = async () => {
        const res = await ApiService.Payment.GetPosDevices(appointmentId)
        const patient = await ApiService.Patient.GetPatient(patientId);

        if (res.success && patient.success) {
            setPosDevices(res.data)
            formRef.current.setFieldsValue({
                posDeviceId: res.data[0]?.id,
                type: type,
                country: 'Türkiye',
                city: 'İstanbul',
                district: 'Pendik',
                isEFaturaMerchant: false,
                name: patient.data.name,
                lastname: patient.data.lastname,
                taxNo: patient.data.customId,
                address: patient.data.address,
                mediatorId: 2
            })
        }
    }

    const onSubmit = async (values) => {
        setError(null)
        const pos = posDevices.find(device => device.id === values.posDeviceId)

        const data = formRef.current.getFieldsValue()
        const res = await ApiService.Payment.PavoGetSaleData({
            mediatorId: data.mediatorId,
            posId: data.posDeviceId,
            paymentId: payment?.id,
            invoiceInformation: {
                ...data
            }
        })

        if (res.success) {
            const sale = JSON.parse(res.data)
            const posRes = await fetch(`${pos?.address}/CompleteSale`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: res.data
            })

            if(posRes.ok) {
                const posData = await posRes.json()
                if (posData?.HasError) {
                    setError(`${posData?.ErrorCode}: ${posData?.Message}`)
                }

                if(posData?.Data?.StatusId === 7) {
                    setError(t('This payment has already been cancelled!'))
                    return
                }

                const savePosRes = await ApiService.Payment.PavoCompleteSale({
                    paymentId: payment?.id,
                    hasError: posData?.HasError,
                    posResponse: JSON.stringify(posData),
                    transactionId: sale?.TransactionHandle?.TransactionSequence,
                })

                if(savePosRes.success && !posData?.HasError) {
                    onSuccess && onSuccess()
                }
            }
            else {
                setError(t('POS device is not reachable!') + ` (${posRes.status})`)
            }
        }
    }

    useEffect(() => {
        getPosDevices()
    }, [appointmentId, patientId])

    useEffect(() => {

    }, [])

    return (
        <div>
            <Form
                ref={formRef}
                onFinish={onSubmit}
                layout={'vertical'}
                size={'small'}
            >
                <Form.Item
                    name="posDeviceId"
                    label="POS"
                    rules={[{required: true, message: t('Please select a POS device!')}]}>
                    <Select
                        options={posDevices.map(device => ({
                            label: device.name,
                            value: device.id
                        }))}/>
                </Form.Item>
                <Form.Item
                    name="mediatorId"
                    label={t('Mediator')}
                    rules={[{required: true, message: t('Please select a mediator ID!')}]}>
                    <Select>
                        <Select.Option value={1}>
                            <div style={{background: 'orange', color: 'black', fontWeight: 'bold', paddingLeft: 8}}>
                                Nakit
                            </div>
                        </Select.Option>
                        <Select.Option value={2}>
                            <div style={{background: 'orange', color: 'black', fontWeight: 'bold', paddingLeft: 8}}>
                                BKM TechPOS (Kredi Karti)
                            </div>
                        </Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label={t('Type')}
                    name={'type'}
                >
                    <Select
                        style={{background: 'red'}}
                        onChange={(val) => {setType(val)}}
                    >
                        <Select.Option value={1}>{'Gerçek Kişi'}</Select.Option>
                        <Select.Option value={2}>{'Tüzel Kişi'}</Select.Option>
                    </Select>
                </Form.Item>
                {
                    type === 1 && (
                        <>
                            <Form.Item
                                name={'name'}
                                label={t("Name")}
                                rules={[{required: true, message: t('Please input your name!')}]}>
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name={'lastname'}
                                label={t('Lastname')}
                                rules={[{required: true, message: t('Please input your lastname!')}]}>
                                <Input />
                            </Form.Item>
                        </>
                    )
                }
                {
                    type === 2 && (
                        <>
                            <Form.Item
                                name={'companyName'}
                                label={t('Company Name')}
                                rules={[{required: true, message: t('Please input your company name!')}]}>
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name={'taxOfficeCode'}
                                label={t('Tax Office Code')}
                                rules={[{required: true, message: t('Please input your tax office code!')}]}>
                                <Input />
                            </Form.Item>
                        </>
                    )
                }

                <Form.Item
                    name={'taxNo'}
                    label={t('Tax Number')}
                    rules={[{required: true, message: t('Please input your tax number!')}]}>
                    <Input />
                </Form.Item>
                <Collapse>
                    <Collapse.Panel key={'extra'} header={'' + t('Extra Information')}>
                        <Form.Item
                            name={'phone'}
                            label={t('Phone')}>
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name={'address'}
                            label={t('Address')}>
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name={'district'}
                            label={t('District')}>
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name={'city'}
                            label={t('City')}>
                            <Input />
                        </Form.Item>

                        <Form.Item
                            name={'country'}
                            label={t('Country')}>
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label={t('E-Invoice Merchant')}
                            name={'isEFaturaMerchant'}
                        >
                            <Select>
                                <Select.Option value={true}>{'Evet'}</Select.Option>
                                <Select.Option value={false}>{'Hayır'}</Select.Option>
                            </Select>
                        </Form.Item>
                    </Collapse.Panel>
                </Collapse>

                <br/>
                <Form.Item>
                    <Button type="primary" htmlType={'submit'}>
                        {t('Transfer') + ' (' + payment?.amount + ' ₺)'}
                    </Button>
                </Form.Item>
                {
                    error && (
                        <Typography.Text style={{color: 'red', fontWeight: 'bold'}}>
                            {error}
                        </Typography.Text>
                    )
                }
            </Form>
        </div>
    )
}